module.exports = __webpack_public_path__ + "img/icon.cc7cbac9.svg";